<!--
  `@if` blocks and no `<ng-container>` — `npm run lint:templates` (the BXS-3584
  guard) rejects host bindings on container nodes, and the built-in blocks make
  that class of mistake impossible rather than merely caught.

  The star is drawn inline rather than pulled from Material's icon font: this
  renders on a public, SSR'd page where the icon font arrives late, and a
  ligature that has not loaded shows the literal word "star" in the corner of
  every card until it does.
-->
<button
  type="button"
  class="ia-fav"
  [class.is-on]="isFavourite"
  [class.is-busy]="busy"
  [class.is-noted]="hasNote"
  [class.ia-fav--card]="variant === 'card'"
  [class.ia-fav--bar]="variant === 'bar'"
  [class.ia-fav--row]="variant === 'row'"
  [attr.aria-pressed]="signedIn ? isFavourite : null"
  [attr.aria-label]="labelKey | translate"
  [attr.title]="labelKey | translate"
  [disabled]="busy"
  (click)="onPress($event)"
>
  <svg
    class="ia-fav__icon"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M12 17.27 6.18 20.4l1.11-6.49-4.71-4.6 6.52-.95L12 2.5l2.9 5.86 6.52.95-4.71 4.6 1.11 6.49z"
    />
  </svg>

  @if (showLabel) {
    <span class="ia-fav__text">{{ labelKey | translate }}</span>
  }

  <!--
    A pencil beside a filled star means "and you wrote something here". It is
    the only way the catalogue can distinguish a lot that was merely starred
    from one the buyer actually assessed, which is the difference between a
    shortlist and a working list.
  -->
  @if (hasNote) {
    <svg
      class="ia-fav__noted"
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
    </svg>
  }
</button>
